export const LIST_HEAR_ABOUT_US = [
    'Instagram',
    'Threads',
    'Facebook',
    'Pinterest',
    'Youtube',
    'LinkedIn',
    'X (ex. Twitter)',
    'News/Media',
    'TikTok',
    'Word of Mouth',
    'Google Search'
];
